import { render, staticRenderFns } from "./deleteBorrowType.vue?vue&type=template&id=cba558f0&scoped=true"
import script from "./deleteBorrowType.vue?vue&type=script&lang=js"
export * from "./deleteBorrowType.vue?vue&type=script&lang=js"
import style0 from "./deleteBorrowType.vue?vue&type=style&index=0&id=cba558f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba558f0",
  null
  
)

export default component.exports